document.addEventListener('DOMContentLoaded', function () {
  const sliders = document.querySelectorAll('.product-cards-new-slider'); // Select all sliders

  sliders.forEach(slider => {
    let isDown = false;
    let startX;
    let scrollLeft;
    const images = slider.querySelectorAll('img'); // Select all images within this slider
    const links = slider.querySelectorAll('a'); // Select all links within this slider

    // Function to make images and links undraggable
    function setImagesDraggable(draggable) {
      images.forEach(img => {
        img.draggable = draggable;
      });
      links.forEach(link => {
        link.draggable = draggable;
      });
    }

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('active');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;

      // Prevent selection of text and make images undraggable
      document.body.style.userSelect = 'none'; // Disable text selection
      document.body.style.cursor = 'grabbing';
      slider.style.scrollBehavior = 'auto'; // Disable smooth scroll while dragging
      setImagesDraggable(false); // Make images undraggable
    });

    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('active');
      document.body.style.userSelect = ''; // Restore text selection
      document.body.style.cursor = 'default'; // Reset cursor
      slider.style.scrollBehavior = 'smooth'; // Re-enable smooth scroll after dragging
      setImagesDraggable(true); // Make images draggable again
    });

    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('active');
      document.body.style.userSelect = ''; // Restore text selection
      document.body.style.cursor = 'default'; // Reset cursor
      slider.style.scrollBehavior = 'smooth'; // Re-enable smooth scroll after dragging
      setImagesDraggable(true); // Make images draggable again
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX); // Determine the drag distance
      slider.scrollLeft = scrollLeft - walk; // Scroll the slider based on drag movement
    });
  });
});